import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FlexItem from "@insite/content-library/Widgets/Brand/FlexItem";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    heading = "heading",
    text = "text",
    link  = "link",
}

interface OwnProps extends WidgetProps{
    fields:{
        path1: LinkFieldValue;
        [fields.image]: string;
        [fields.text]: string;
        [fields.heading]: string;
    }
}

export interface ServiceCardStyles {
    wrapper?: InjectableCss;
    img?: InjectableCss;
    heading?: InjectableCss;
    text?: InjectableCss;
    maintxt?: InjectableCss;
    mainwrapper?: InjectableCss;
}

export const serviceCardStyles: ServiceCardStyles = {
    mainwrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0px 30px 30px 30px;
                `,
                null,
                null,
                null,
                null,
            ])}
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
        `,
    },
    maintxt: {
        css: css`
            min-height: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    min-height: 70px;
                `,
                css`
                   min-height: 210px;
                `,
                css`
                    min-height: 210px;
                `,
                null,
                null,
            ])}
        `,
    },
    heading: {
        css:css`
            font-size: 18px;
            font-weight: bold;
            margin: 0 0 0.5rem 0;
            text-transform: uppercase;
            &:hover{
                text-decoration: underline;
            }
            > span {
                color: ${getColor("secondary")} !important;
            }
        `,
    },
    text: {
        css:css` 
            font-size: 12px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                null,
                null,
            ],"max",
            )}
        `,
    },
};
const styles = serviceCardStyles;

const ServiceCards: React.FC<OwnProps> = ({ fields }) => {
    const links1 = useGetLink(fields.path1); 
    return(
        <>
            <StyledWrapper {...styles.mainwrapper}>
                <StyledWrapper {...styles.wrapper}>
                    <LazyImage src={fields.image} {...styles.img}></LazyImage>
                    <StyledWrapper {...styles.maintxt}>
                        <Link href={links1.url} {...styles.heading}>
                            {fields.heading}
                        </Link>
                        <StyledWrapper {...styles.text}>{fields.text}</StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ServiceCards,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.image,
                displayName: "Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.heading,
                displayName: "Heading",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.text,
                displayName: "Text",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },
            {
                name: "path1",
                fieldType: "General",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
        ],
    },
};

export default widgetModule;